/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DashboardWidget } from './DashboardWidget';
import {
    DashboardWidgetFromJSON,
    DashboardWidgetFromJSONTyped,
    DashboardWidgetToJSON,
    DashboardWidgetToJSONTyped,
} from './DashboardWidget';

/**
 * The current dashboard handed to the dashboard_agent via ConversationMetadata.
 * 
 * Input-only (never written back by the agent): the frontend re-supplies the current
 * dashboard — reflecting the applied filters/time range — on every turn.
 * @export
 * @interface DashboardAgentState
 */
export interface DashboardAgentState {
    /**
     * 
     * @type {string}
     * @memberof DashboardAgentState
     */
    templateId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardAgentState
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardAgentState
     */
    timeRange?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardAgentState
     */
    timezone?: string | null;
    /**
     * 
     * @type {Array<DashboardWidget>}
     * @memberof DashboardAgentState
     */
    widgets?: Array<DashboardWidget>;
}

/**
 * Check if a given object implements the DashboardAgentState interface.
 */
export function instanceOfDashboardAgentState(value: object): value is DashboardAgentState {
    return true;
}

export function DashboardAgentStateFromJSON(json: any): DashboardAgentState {
    return DashboardAgentStateFromJSONTyped(json, false);
}

export function DashboardAgentStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardAgentState {
    if (json == null) {
        return json;
    }
    return {
        
        'templateId': json['template_id'] == null ? undefined : json['template_id'],
        'name': json['name'] == null ? undefined : json['name'],
        'timeRange': json['time_range'] == null ? undefined : json['time_range'],
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
        'widgets': json['widgets'] == null ? undefined : ((json['widgets'] as Array<any>).map(DashboardWidgetFromJSON)),
    };
}

export function DashboardAgentStateToJSON(json: any): DashboardAgentState {
    return DashboardAgentStateToJSONTyped(json, false);
}

export function DashboardAgentStateToJSONTyped(value?: DashboardAgentState | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'template_id': value['templateId'],
        'name': value['name'],
        'time_range': value['timeRange'],
        'timezone': value['timezone'],
        'widgets': value['widgets'] == null ? undefined : ((value['widgets'] as Array<any>).map(DashboardWidgetToJSON)),
    };
}

